var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBoleto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2517 3.49023H24.3047V20.53H22.2517V3.49023Z",
    fill: "#0E4C54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.29801 1.4359V22.5641H26.702V1.4359H1.29801ZM0.927152 0C0.4151 0 0 0.459195 0 1.02564V22.9744C0 23.5408 0.4151 24 0.927152 24H27.0728C27.5849 24 28 23.5408 28 22.9744V1.02564C28 0.459195 27.5849 0 27.0728 0H0.927152Z",
    fill: "#0E4C54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15894 3.49023H5.41721V20.53H3.15894V3.49023Z",
    fill: "#0E4C54"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5497 3.49023H12.6027V20.53H10.5497V3.49023Z",
    fill: "#0E4C54"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5828 3.49023H21.0198V20.53H19.5828V3.49023Z",
    fill: "#0E4C54"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.298 3.49023H17.5298V20.53H16.298V3.49023Z",
    fill: "#0E4C54"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8345 3.49023H15.0663V20.53H13.8345V3.49023Z",
    fill: "#0E4C54"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88086 3.49023H9.11265V20.53H7.88086V3.49023Z",
    fill: "#0E4C54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoleto);
export default __webpack_public_path__ + "static/media/icon-boleto.6084eebc25f7d667f279ceca246b0e11.svg";
export { ForwardRef as ReactComponent };